import { localWallTimeToIso } from '../../utils/activityDateTime';
import {
  buildRecurrenceFromForm,
  expandOccurrenceYmds,
  type RecurrenceFormState,
} from '../../utils/activityRecurrence';

/** Termine, die „Anlegen“ im Plantafel-Formular erzeugen würde; Vorschau auf der Tafel. */
export type PlantafelCreatePreview = Array<{ due_at: string; end_at: string }>;

/**
 * Serie: ein Termin je Wiederholungstag von Von bis Bis am selben Tag (wie beim Speichern).
 * Sonst ein Termin von Start bis Ende. `null` = Formular noch unvollständig, Tafel zeigt den Entwurf.
 */
export function plantafelCreatePreview(
  form: {
    dueDate: string;
    endDate: string;
    dueTimeStart: string;
    dueTimeEnd: string;
    recurrence?: RecurrenceFormState;
  },
  timeZone: string,
  opts?: { ignoreRecurrence?: boolean },
): PlantafelCreatePreview | null {
  if (!form.dueDate || !form.dueTimeStart || !form.dueTimeEnd) return null;
  const rec = opts?.ignoreRecurrence ? null : form.recurrence;
  if (rec && rec.freq !== 'none') {
    const built = buildRecurrenceFromForm(rec, form.dueDate);
    if ('error' in built || !built.value) return null;
    const expanded = expandOccurrenceYmds(built.value, form.dueDate);
    if ('error' in expanded) return null;
    return expanded.dates.map((ymd) => ({
      due_at: localWallTimeToIso(ymd, form.dueTimeStart, timeZone),
      end_at: localWallTimeToIso(ymd, form.dueTimeEnd, timeZone),
    }));
  }
  return [
    {
      due_at: localWallTimeToIso(form.dueDate, form.dueTimeStart, timeZone),
      end_at: localWallTimeToIso(form.endDate || form.dueDate, form.dueTimeEnd, timeZone),
    },
  ];
}
